<template>
  <div>
    <PageTitle title="Order Bills" />
    <v-container fluid class="lighten-12">
      <v-row>
        <v-col cols="12" md="12" class="pa-3">
          <v-card class>
            <v-tabs v-model="tab" background-color="white" color="primary" slider-color="primary">
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-for="item in items" :key="item.tab">
                {{ item.tab }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in items" :key="item.tab">
                <SuspendedBills v-if="item.tab === 'All Bills'" />
                <PartiallyPaid v-if="item.tab === 'Partially Bills'" />
                <PaidBills v-if="item.tab== 'Paid Bills'"/>
                  <!-- <ReceivingBills v-if="item.tab== 'Receiving Bills'"/> -->
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import PartiallyPaid from "./PartiallyBill";
import SuspendedBills from "./SuspendedBills"
import PaidBills from "./PaidBills"
import ReceivingBills from "./ReceivingBill"
export default {
  data() {
    return {
      items: [
        { tab: "All Bills", content: "this is credit tab" },
        { tab: "Partially Bills", content: "this is credit tab" },
        { tab: "Paid Bills", content: "this is credit tab" },
          // { tab: "Receiving Bills", content: "this is credit tab" },
      ],
       tab: "Credit",
    };
  },
  components: {
      PartiallyPaid,
      SuspendedBills,
      PaidBills,
      // ReceivingBills
  },
};
</script>
